
<mat-card class="mat-form">
  <mat-card-title>
    Configuración
  </mat-card-title>
  <form *ngIf="profileForm" [formGroup]="profileForm" (ngSubmit)="onSubmit()" >
  
    <input style="visibility: hidden; height: 0px; width: 0;" type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileInput (change)="uploadFile($event)" />
    <div class="page-form-image" style="display: flex; flex-flow: column; align-items: center; justify-content: center;" *ngIf="imageUrl">
        <img class="event-image"  [src]="imageUrl" alt="">
        <br>
        <button mat-icon-button (click)="deleteImage()">
            <mat-icon color="accent" >delete_outline</mat-icon>
        </button>
        <br>
    </div>
        
    <div *ngIf="!imageUrl" style="text-align: center; margin-bottom: 24px;">
        <button style="border: 2px dotted; height: 120px; border-radius: 50%; text-align: center;" (click)="fileInput.click()" mat-button color="accent" >
            Imagén de pérfil
        </button>
    </div>
  
    <mat-form-field class="form-group w-100" color="accent" appearance="outline">
      <mat-label>Email</mat-label>
      <input type="text" matInput formControlName="email" [value]="user?.email" readonly />
    </mat-form-field>
    <mat-form-field class="form-group w-100" color="accent"appearance="outline">
      <mat-label>Display Name</mat-label>
      <input type="text" matInput formControlName="displayName" />
    </mat-form-field>

    <mat-form-field class="form-group w-100" color="accent"appearance="outline">
      <mat-label>Cuenta de instagram</mat-label>
      <input type="text" matInput formControlName="instagram" />
    </mat-form-field>

    <mat-form-field appearance="outline" color="accent" class="form-group w-100">
      <mat-label>Link a google maps</mat-label>
      <input type="text" matInput formControlName="locationLink" />
      <mat-error >
        El link debe ser google maps con la forma https://maps....
      </mat-error>
    </mat-form-field>
  
    <mat-form-field class="form-group w-100" color="accent" appearance="outline">
      <mat-label>Biografía</mat-label>
      <textarea matInput formControlName="bio"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="1"
                  cdkAutosizeMaxRows="10">
              </textarea>
    </mat-form-field>

    <mat-form-field class="form-group w-100" color="accent" appearance="outline">
      <mat-label>Contacto de whatsapp </mat-label>
      <input matInput formControlName="whatsapp" placeholder="584241234567">
    </mat-form-field>
  
    <!-- <mat-form-field class="form-group" appearance="outline">
      <mat-label>Google Maps URL</mat-label>
      <input type="text" matInput formControlName="googleMapsUrl" />
    </mat-form-field>
    <mat-form-field class="form-group" appearance="outline">
      <mat-label>Work Hours</mat-label>
      <input type="text" matInput formControlName="workHours" />
    </mat-form-field> -->
    <button type="submit" mat-raised-button [disabled]="!profileForm.valid" class="w-100" color="primary">Guardar</button>
  </form>
</mat-card>
